import cx from "classnames";
import React from "react";

import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";

import styles from "./FeedPost.mscss";

interface OwnProps {
    isMobile: boolean;
    lengths?: "v1" | "v2" | "v3";
}

export class FeedPostPlaceholder extends React.Component<OwnProps> {
    /**
     *  height of post placeholder (including border and padding)
     */
    public static height(isMobile: boolean): number {
        return isMobile ? 92 : 68; // rovnaka vyska ako FeedPost (verzia len s textom bez obrazku)
    }

    /**
     *  height of post placeholder (including margins)
     */
    public static outerHeight(isMobile: boolean): number {
        return FeedPostPlaceholder.height(isMobile);
    }

    private static lengthVariants = {
        v1: [250, 150, 30, 80, 120],
        v2: [220, 0, 50, 100, 100],
        v3: [250, 60, 50, 80, 120],
    };

    public render() {
        const { isMobile } = this.props;

        const lengths = FeedPostPlaceholder.lengthVariants[this.props.lengths || "v1"];

        return (
            <div
                className={cx(styles.FeedPost, styles["FeedPost--active"])}
                style={{ height: FeedPostPlaceholder.height(isMobile) }}
            >
                <div className={styles.FeedPost__header}>
                    <div className={styles.FeedPost__header__heading}>
                        <LoadingPlaceholder width={lengths[0]} height={18} />
                        {isMobile && <LoadingPlaceholder width={lengths[1]} height={18} />}
                    </div>
                    <div className={styles.FeedPost__header__comments}>
                        <LoadingPlaceholder width={lengths[2]} height={18} />
                    </div>
                </div>

                <div className={styles.FeedPost__footer}>
                    <div className={styles.FeedPost__footer__left}>
                        <div className={styles.FeedPost__footer__left__link}>
                            <LoadingPlaceholder
                                className={styles.FeedPost__footer__left__color}
                                width={14}
                                height={14}
                            />
                            <LoadingPlaceholder width={lengths[3]} height={14} />
                        </div>
                    </div>

                    <div className={styles.FeedPost__footer__date}>
                        <LoadingPlaceholder width={lengths[4]} height={14} />
                    </div>
                </div>
            </div>
        );
    }
}
